<template>
    <div class="loading section">
        <GridLines />
        <div>
            <h1>loading...</h1>
        </div>
    </div>
</template>
<script>
import GridLines from "./GridLines.vue"

export default {
    components:{
        GridLines
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .loading.section{
        background-color: #14182E;
        color: #fff;
        position: absolute;
        width: 100%;
        height: 100%;
        top:0;
        left: 0;
        bottom: 0;
        justify-content: center;
        align-items: center;
        display: flex;
        h1{
            font-size: 1rem;
            letter-spacing: 3px;
        }
    }
</style>
